import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  inject,
  input,
} from '@angular/core';

const BUTTON_HOST_ATTRIBUTES: string[] = ['ui-client-button'];

const BUTTON_STYLE_CLASSES: { [name: string]: { [name: string]: string } } = {
  'ui-client-button': {
    default: 'bg-white text-body',
    primary: 'bg-gradient-to-b from-dark-1 to-dark-2 text-light',
    outline: 'bg-white text-teal-seed border-[1.5px] border-teal-seed',
    teal: 'bg-teal-seed text-white',
  },
};

@Component({
  selector: 'button[ui-portal-button], a[ui-portal-button]',
  imports: [],
  templateUrl: './portal-button.component.html',
})
export class PortalButtonComponent implements AfterViewInit {
  private _elementRef = inject(ElementRef);

  readonly style = input('');
  @Input() color = '';
  readonly textColor = input('text-white');
  readonly disabled = input(false);
  readonly isFull = input(false);
  readonly isLarge = input(false);
  readonly hasBorder = input(false);
  readonly height = input('');
  readonly width = input('');

  @HostBinding('attr.disabled') get valid() {
    return this.disabled() ? 'disabled' : null;
  }

  constructor() {
    // Add basic classes
    this.getHostElement().classList.add(
      'inline-flex',
      'items-center',
      'justify-center',
      'rounded-[50px]',
      'text-[16px]',
      'h-[52px]',
      'px-8'
    );
  }

  ngAfterViewInit(): void {
    this.color = this.color || 'default';
    this.addToClassList(this.color);

    const style = this.style();
    if (style)
      this.addToClassList(BUTTON_STYLE_CLASSES['ui-client-button'][style]);

    if (this.isFull()) {
      this.addToClassList('w-full');
    }
    const width = this.width();
    if (width) {
      this.addToClassList(width);
    }
    const height = this.height();
    if (height) {
      this.addToClassList(height);
    }
    if (this.hasBorder()) {
      this.addToClassList('border border-gray-seed');
    }
  }

  private addToClassList(className: string) {
    const classes = className.split(' ');
    this.getHostElement().classList.add(...classes);
  }

  private hasHostAttributes(...attributes: string[]) {
    return attributes.some((attribute) =>
      this.getHostElement().hasAttribute(attribute)
    );
  }

  private getHostElement(): HTMLElement {
    return this._elementRef.nativeElement;
  }
}
